// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2fASz","loaderOuter":"PageOverlayLoader_loaderOuter__1ZxXM"};